/* eslint-disable react/jsx-curly-newline */
import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaRegQuestionCircle,
  FaRegCheckCircle,
  FaRegMoneyBillAlt,
  FaRegThumbsUp,
  FaBan,
  FaRegClock,
  FaRegCalendarCheck,
} from 'react-icons/fa';
// import { Container } from './styles';

import { Colors } from '../../styles/constants';

import Button from '../Button';

import {
  IFilaChamado,
  IListaAgendamentosHojeDTO,
} from '../../pages/AgendaAtendimento';
import { STATUS_AGENDA } from '../../utils/funcoes';
import { useAuth } from '../../hooks/auth';

interface IIcons {
  [key: string]: JSX.Element;
}

const icons: IIcons = {
  ban: <FaBan size={15} />,
  question: <FaRegQuestionCircle size={15} />,
  check: <FaRegCheckCircle size={15} />,
  money: <FaRegMoneyBillAlt size={15} />,
  clock: <FaRegClock size={15} />,
  thumbs: <FaRegThumbsUp size={15} />,
  calendar: <FaRegCalendarCheck size={15} />,
};

type listaProps = {
  listaEspera: IListaAgendamentosHojeDTO[];
  dadosBusca: {
    dataAgenda: string;
    codigoAgenda: string | undefined;
    somenteLista: boolean;
  };
  exibeBotoesAcao?: boolean;
  chamar(pacNome: string): void;
  chamarPainel(dados: IFilaChamado): void;
  abrirHistorico(pacCodigo: number): void;
  sala?: string;
};
const ListaAtendimentoConsulta: React.FC<listaProps> = ({
  listaEspera,
  dadosBusca,
  chamar,
  chamarPainel,
  abrirHistorico,
  exibeBotoesAcao = true,
  sala = '',
}) => {
  const { clinica } = useAuth();

  return (
    <>
      {listaEspera && listaEspera.length > 0 ? (
        <table
          className="table table-hover table-sm table-font-small"
          style={{ borderWidth: '0px' }}
        >
          <thead>
            <tr className="bg-light" style={{ fontSize: 'Small' }}>
              <th scope="col">&nbsp;</th>
              <th scope="col">Horário</th>
              <th scope="col">Liberado às</th>
              <th scope="col">Paciente</th>
              <th scope="col">Idade</th>
              {clinica.CliExibeConvenioMedico && <th scope="col">Convênio</th>}
              {/* <th scope="col">Celular</th> */}
              <th scope="col">Procedimento</th>
              <th scope="col">Observação</th>
              {(exibeBotoesAcao || clinica.CliUsaPainel) && (
                <th scope="col">Ação</th>
              )}
            </tr>
          </thead>
          <tbody>
            {listaEspera.map((lista: IListaAgendamentosHojeDTO) => (
              <tr
                key={lista.AgeCodigo}
                style={{
                  fontSize: 'Small',
                  height: '30px',
                  color:
                    lista.AgeStatus === STATUS_AGENDA.ATENDIDO
                      ? Colors.success
                      : '#000',
                  fontWeight:
                    lista.idadeNumero && lista.idadeNumero >= 80
                      ? 'bold'
                      : 'normal',
                }}
              >
                <td
                  style={{
                    width: '50px',
                    color: lista.icone?.color,
                    textAlign: 'center',
                  }}
                >
                  {icons[lista.icone?.icon || 'question']}
                </td>
                <td style={{ width: '80px' }}>{lista.horario}</td>
                <td style={{ width: '80px' }}>{lista.liberado}</td>
                <td>
                  {lista.PacNomeSocial.trim() !== ''
                    ? `Nome Social: ${lista.PacNomeSocial} - ${lista.PacNome}`
                    : lista.PacNome}
                </td>
                <td style={{ width: '80px' }}>{lista.idade}</td>
                {clinica.CliExibeConvenioMedico && (
                  <td style={{ width: '150px' }}>{lista.ConvNome}</td>
                )}
                {/* <td style={{ width: '120px' }}>
                  {`${lista.celular || lista.PacCelular}`}
                </td> */}
                <td>{lista.Procedimento}</td>
                <td>{lista.AgeObsMedico}</td>
                {(exibeBotoesAcao || clinica.CliUsaPainel) && (
                  <td className="p-0" style={{ width: '330px' }}>
                    {exibeBotoesAcao && (
                      <Link
                        className={`btn btn-primary ${
                          lista.AgeStatus ===
                            STATUS_AGENDA.AGUARDANDO_ATENDIMENTO ||
                          lista.AgeStatus === STATUS_AGENDA.ATENDIDO
                            ? ''
                            : 'd-none'
                        }`}
                        style={{
                          height: '23px',
                          lineHeight: 1,
                          padding: '4px 16px',
                          fontSize: '14px',
                        }}
                        to={`/pacienteAtendimento/${lista.AgeCodigo.toString()}?agenda=${
                          dadosBusca.codigoAgenda
                        }&data=${dadosBusca.dataAgenda}&somenteLista=${
                          dadosBusca.somenteLista
                        }${
                          clinica.CliExibeConvenioMedico
                            ? `&convenio=${lista.ConvNome}`
                            : ''
                        }`}
                      >
                        {lista.atendido ? 'Atendido' : 'Atender'}
                      </Link>
                    )}
                    {exibeBotoesAcao && !clinica.CliUsaPainel && (
                      <Button
                        type="button"
                        variant="primary-outline"
                        className={`py-0 ${
                          lista.atendido ||
                          (lista.AgeStatus <
                            STATUS_AGENDA.AGUARDANDO_ATENDIMENTO &&
                            lista.AgeStatus !==
                              STATUS_AGENDA.PAGAMENTO_ANTECIPADO)
                            ? 'd-none'
                            : ''
                        }`}
                        style={{ height: '23px' }}
                        onClick={() =>
                          chamar(
                            lista.PacNomeSocial.trim() !== ''
                              ? `Nome Social: ${lista.PacNomeSocial} - ${lista.PacNome}`
                              : lista.PacNome,
                          )
                        }
                        disabled={sala === '' && clinica.CliUsaPainel}
                      >
                        Chamar Paciente
                      </Button>
                    )}
                    {clinica.CliUsaPainel && (
                      <Button
                        type="button"
                        variant="primary-outline"
                        className={`py-0 ${
                          lista.AgeStatus ===
                            STATUS_AGENDA.AGUARDANDO_ATENDIMENTO ||
                          lista.AgeStatus === STATUS_AGENDA.ATENDIDO
                            ? ''
                            : 'd-none'
                        }`}
                        style={{ height: '23px' }}
                        onClick={() =>
                          chamarPainel({
                            AgeCodigo: lista.AgeCodigo,
                            PacCodigo: lista.PacCodigo,
                            PacNome:
                              lista.PacNomeSocial.trim() !== ''
                                ? lista.PacNomeSocial
                                : lista.PacNome,
                            Sala: sala,
                            Texto: `${
                              lista.PacNomeSocial.trim() !== ''
                                ? lista.PacNomeSocial
                                : lista.PacNome
                            }, ${sala}`,
                          })
                        }
                        disabled={sala === ''}
                      >
                        Chamar Paciente
                      </Button>
                    )}
                    {exibeBotoesAcao && (
                      <Button
                        type="button"
                        variant="primary-outline"
                        className="py-0"
                        style={{ height: '23px' }}
                        onClick={() => abrirHistorico(lista.PacCodigo)}
                        title={lista.PacCodigo.toString()}
                      >
                        Histórico
                      </Button>
                    )}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '5%',
          }}
        >
          <span>
            <h3>
              Médico não possui agenda configurada para atender em consultório
            </h3>
          </span>
        </div>
      )}
    </>
  );
};
export default ListaAtendimentoConsulta;
